import { systemCode } from '@root/package.json';

/** 当前系统编码 */
export const CURRENT_CLIENT_CODE = systemCode;

// eslint-disable-next-line vue/max-len
export const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCeVP2WiGkdj72eCo3SWVU57m/0ExOjG6lVfSHJt0e4/IlXh3TjiVs5citWezYfHdueGFi88923P0uvL++UOXpX5iBlG1vAngt7Rbjm2gP7l6smHhUZadpgYlT6/j4Dy7XDkRzAIC1fU2smz3mCuJG9JG87aO6icD8dkTE8YpdIMwIDAQAB';
